import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

export const handleStockAnalysisExcelExport = (stockAnalysisItems) => {
  const worksheetData = stockAnalysisItems.map((item) => ({
    Code: item.productCode,
    Name: item.productName,
    BP: item.bpCount,
    BV: item.bvValue,
    CP: item.cpValue,
    Cost: item.costPrice,
    Category: item.category,
    "Total Stock": item.totalStock,
    "Sold Units": item.soldUnits,
  }));

  const worksheet = XLSX.utils.json_to_sheet(worksheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Analysis");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const data = new Blob([excelBuffer], {
    type: "application/octet-stream",
  });

  saveAs(data, `Stock_Analysis_Report_${new Date().toLocaleDateString()}.xlsx`);
};
